import { render, staticRenderFns } from "./courseData_index.vue?vue&type=template&id=13fa450f&scoped=true&"
import script from "./courseData_index.vue?vue&type=script&lang=js&"
export * from "./courseData_index.vue?vue&type=script&lang=js&"
import style0 from "./courseData_index.vue?vue&type=style&index=0&id=13fa450f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa450f",
  null
  
)

export default component.exports